(() => {
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];
  const root = window.Shopify?.routes?.root || '/';

  function money(cents, currency='EUR') {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'bg-BG', { style:'currency', currency }).format(cents / 100); }
    catch(e) { return `€${(cents/100).toFixed(2)}`; }
  }

  const cartShell = qs('[data-cart-shell]');
  function openCart() {
    if (!cartShell) return;
    cartShell.classList.add('is-open');
    cartShell.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-open');
  }
  function closeCart() {
    if (!cartShell) return;
    cartShell.classList.remove('is-open');
    cartShell.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-open');
  }

  async function getCart(){
    const r = await fetch(`${root}cart.js`, {headers:{'Accept':'application/json'}});
    return r.json();
  }

  function renderCart(cart){
    qsa('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
    const titleCount = qs('[data-cart-title-count]'); if (titleCount) titleCount.textContent = `(${cart.item_count})`;
    const total = qs('[data-cart-total]'); if(total) total.textContent = money(cart.total_price, cart.currency || 'EUR');
    const items = qs('[data-cart-items]');
    const empty = qs('[data-cart-empty]');
    const footer = qs('[data-cart-footer]');
    if(items){
      items.innerHTML = cart.items.map(item => `
        <article class="drawer-line" data-key="${item.key}">
          <a class="drawer-line__media" href="${item.url}">${item.image ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=320" alt="${escapeHtml(item.product_title)}">` : ''}</a>
          <div class="drawer-line__info">
            <div class="drawer-line__top"><a href="${item.url}">${escapeHtml(item.product_title)}</a><button type="button" class="drawer-remove" data-remove-key="${item.key}" aria-label="Премахни">×</button></div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : ''}
            <div class="drawer-line__bottom">
              <div class="qty-stepper"><button type="button" data-qty-key="${item.key}" data-qty="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button type="button" data-qty-key="${item.key}" data-qty="${item.quantity+1}">+</button></div>
              <strong>${money(item.final_line_price, cart.currency || 'EUR')}</strong>
            </div>
          </div>
        </article>`).join('');
    }
    empty?.classList.toggle('is-hidden', cart.item_count > 0);
    footer?.classList.toggle('is-hidden', cart.item_count === 0);

    const meter = qs('[data-free-shipping]');
    if(meter){
      const threshold = Number(meter.dataset.threshold || 9000);
      const remaining = Math.max(0, threshold - cart.total_price);
      const pct = Math.min(100, (cart.total_price / threshold) * 100);
      const msg = qs('[data-shipping-message]', meter);
      const bar = qs('[data-shipping-progress]', meter);
      if(msg) msg.textContent = remaining <= 0 ? 'Имаш безплатна доставка.' : `Остават ${money(remaining, cart.currency || 'EUR')} до безплатна доставка.`;
      if(bar) bar.style.width = `${pct}%`;
    }
  }

  function escapeHtml(str=''){ const d=document.createElement('div'); d.textContent=str; return d.innerHTML; }

  async function changeLine(key, quantity){
    const r = await fetch(`${root}cart/change.js`, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key,quantity})});
    const cart = await r.json(); renderCart(cart);
  }

  function flyToCart(source){
    const target = qs('.cart-trigger');
    if(!source || !target) return;
    const src = source.getBoundingClientRect(), dst = target.getBoundingClientRect();
    const clone = source.cloneNode(true);
    clone.className = 'fly-to-cart';
    Object.assign(clone.style,{left:`${src.left}px`,top:`${src.top}px`,width:`${src.width}px`,height:`${src.height}px`,opacity:'1'});
    document.body.appendChild(clone);
    requestAnimationFrame(()=>{
      clone.style.left = `${dst.left + dst.width/2 - 18}px`;
      clone.style.top = `${dst.top + dst.height/2 - 18}px`;
      clone.style.width = '36px'; clone.style.height = '36px'; clone.style.opacity = '.2'; clone.style.transform='rotate(6deg) scale(.7)';
    });
    setTimeout(()=>clone.remove(),760);
  }

  function toast(){ const t=qs('[data-cart-toast]'); if(!t)return; t.classList.add('is-visible'); setTimeout(()=>t.classList.remove('is-visible'),1500); }

  document.addEventListener('DOMContentLoaded', () => {
    const menu = qs('.mobile-drawer');
    qs('[data-menu-open]')?.addEventListener('click',()=>{menu?.classList.add('is-open');document.body.classList.add('menu-open')});
    qs('[data-menu-close]')?.addEventListener('click',()=>{menu?.classList.remove('is-open');document.body.classList.remove('menu-open')});

    qsa('[data-cart-open]').forEach(b=>b.addEventListener('click', async ()=>{menu?.classList.remove('is-open');document.body.classList.remove('menu-open'); try{renderCart(await getCart())}catch(e){} openCart();}));
    qsa('[data-cart-close]').forEach(b=>b.addEventListener('click',closeCart));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart()});

    document.addEventListener('click', e => {
      const remove = e.target.closest('[data-remove-key]'); if(remove){ changeLine(remove.dataset.removeKey,0); return; }
      const qty = e.target.closest('[data-qty-key]'); if(qty){ changeLine(qty.dataset.qtyKey, Number(qty.dataset.qty)); return; }
      const minus = e.target.closest('[data-product-qty-minus]');
      const plus = e.target.closest('[data-product-qty-plus]');
      if(minus || plus){ const box=(minus||plus).closest('.qty-input'); const input=qs('input[type=number]',box); const next=Math.max(1,Number(input.value||1)+(plus?1:-1)); input.value=next; }
    });

    qsa('[data-variant-select]').forEach(sel=>sel.addEventListener('change',e=>{const opt=e.target.selectedOptions[0];const price=qs('[data-product-price]');if(price&&opt.dataset.price)price.textContent=opt.dataset.price;}));

    qsa('form[data-ajax-cart]').forEach(form=>form.addEventListener('submit', async e=>{
      e.preventDefault();
      const btn=qs('button[type=submit]',form); const original=btn?.innerHTML;
      if(btn){btn.disabled=true;btn.textContent='Добавяне…';}
      const source=qs('[data-product-media] img') || qs('.product-card__image img');
      flyToCart(source);
      try{
        const r=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!r.ok) throw new Error('cart');
        renderCart(await getCart()); toast(); setTimeout(openCart,430);
      }catch(err){ window.location.href=`${root}cart`; }
      finally{if(btn){btn.disabled=false;btn.innerHTML=original;}}
    }));

    const observer=new IntersectionObserver(entries=>entries.forEach(en=>{if(en.isIntersecting)en.target.classList.add('is-visible')}),{threshold:.08});
    qsa('.section-head,.product-card,.look,.video-story,.benefit,.manifesto-v3__top,.manifesto-card,.review-card').forEach(el=>{el.setAttribute('data-reveal','');observer.observe(el)});
  });
})();

/* ===== MD CLOTHING V6 / PREMIUM UX ===== */
(() => {
  const qs=(s,c=document)=>c.querySelector(s), qsa=(s,c=document)=>[...c.querySelectorAll(s)];
  const root=window.Shopify?.routes?.root || '/';
  document.addEventListener('DOMContentLoaded',()=>{
    const loader=qs('[data-site-loader]');
    if(loader){const duration=Number(document.body.dataset.loaderDuration||700);setTimeout(()=>loader.classList.add('is-hidden'),duration);}

    const header=qs('.site-header');
    if(header){
      const shrinkEnabled=document.body.dataset.headerShrink==='true';
      const autoHideEnabled=document.body.dataset.headerAutohide==='true';
      const glassEnabled=document.body.dataset.headerGlass==='true';
      const hideAfter=Math.max(80,Number(document.body.dataset.headerHideAfter||140));
      const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let lastY=Math.max(0,window.scrollY);
      let ticking=false;

      const updateHeader=()=>{
        const y=Math.max(0,window.scrollY);
        const delta=y-lastY;

        if(shrinkEnabled) header.classList.toggle('is-compact',y>56);
        if(glassEnabled) header.classList.toggle('is-scroll-glass',y>20);

        // Never hide while a drawer is open, close to the top, or for tiny scroll jitter.
        const uiOpen=document.body.classList.contains('menu-open') || document.body.classList.contains('cart-open');
        if(autoHideEnabled && !reduceMotion && !uiOpen && y>hideAfter && Math.abs(delta)>4){
          if(delta>0){
            header.classList.add('is-hidden-by-scroll');
            header.classList.remove('is-scroll-visible');
          }else{
            header.classList.remove('is-hidden-by-scroll');
            header.classList.add('is-scroll-visible');
          }
        }else if(y<=hideAfter || uiOpen || !autoHideEnabled){
          header.classList.remove('is-hidden-by-scroll');
          header.classList.add('is-scroll-visible');
        }

        lastY=y;
        ticking=false;
      };

      const onScroll=()=>{
        if(!ticking){
          window.requestAnimationFrame(updateHeader);
          ticking=true;
        }
      };
      updateHeader();
      window.addEventListener('scroll',onScroll,{passive:true});

      // Opening navigation/cart should always bring the header back immediately.
      document.addEventListener('click',(e)=>{
        if(e.target.closest('[data-menu-open],[data-cart-open]')){
          header.classList.remove('is-hidden-by-scroll');
          header.classList.add('is-scroll-visible');
        }
      });
    }

    const cursor=qs('[data-md-cursor]');
    if(cursor){
      window.addEventListener('mousemove',e=>{cursor.style.left=e.clientX+'px';cursor.style.top=e.clientY+'px'});
      document.addEventListener('mouseover',e=>{const t=e.target.closest('[data-cursor-text]');if(!t)return;cursor.classList.add('is-active');const span=qs('span',cursor);if(span)span.textContent=t.dataset.cursorText||'';});
      document.addEventListener('mouseout',e=>{if(e.target.closest('[data-cursor-text]'))cursor.classList.remove('is-active');});
    }

    const search=qs('[data-search-overlay]'), input=qs('[data-predictive-input]'), results=qs('[data-predictive-results]');
    const openSearch=()=>{search?.classList.add('is-open');search?.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';setTimeout(()=>input?.focus(),150)};
    const closeSearch=()=>{search?.classList.remove('is-open');search?.setAttribute('aria-hidden','true');document.body.style.overflow=''};
    qsa('[data-search-open]').forEach(b=>b.addEventListener('click',openSearch));qs('[data-search-close]')?.addEventListener('click',closeSearch);
    let searchTimer;
    input?.addEventListener('input',()=>{clearTimeout(searchTimer);const q=input.value.trim();if(q.length<2){if(results)results.innerHTML='<p>Въведи поне 2 символа.</p>';return;}searchTimer=setTimeout(async()=>{try{const r=await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=4`);const d=await r.json();const products=d.resources?.results?.products||[];results.innerHTML=products.length?`<div class="predictive-results__grid">${products.map(p=>`<a class="predictive-result" href="${p.url}">${p.image?`<img src="${p.image}" alt="">`:''}<strong>${escapeHtmlV6(p.title)}</strong><span>${p.price||''}</span></a>`).join('')}</div>`:'<p>Няма намерени продукти.</p>';}catch(e){results.innerHTML='<p>Отвори страницата за търсене, за да видиш всички резултати.</p>'; }},220)});

    qsa('[data-countdown-section]').forEach(sec=>{const end=new Date(sec.dataset.end).getTime();if(!Number.isFinite(end))return;const tick=()=>{let x=Math.max(0,end-Date.now());const d=Math.floor(x/86400000);x%=86400000;const h=Math.floor(x/3600000);x%=3600000;const m=Math.floor(x/60000);const s=Math.floor((x%60000)/1000);const set=(sel,v)=>{const el=qs(sel,sec);if(el)el.textContent=String(v).padStart(2,'0')};set('[data-days]',d);set('[data-hours]',h);set('[data-minutes]',m);set('[data-seconds]',s)};tick();setInterval(tick,1000)});

    const lightbox=qs('[data-image-lightbox]'), lightImg=qs('[data-lightbox-image]');
    document.addEventListener('click',e=>{const z=e.target.closest('[data-image-zoom]');if(z&&lightbox&&lightImg){lightImg.src=z.dataset.zoomSrc;lightbox.classList.add('is-open');lightbox.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}if(e.target.closest('[data-lightbox-close]')){lightbox?.classList.remove('is-open');document.body.style.overflow='';}});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&lightbox?.classList.contains('is-open')){lightbox.classList.remove('is-open');document.body.style.overflow='';}});

    const rv=qs('[data-recently-viewed-section]');
    if(rv){const current=rv.dataset.currentHandle;let handles=[];try{handles=JSON.parse(localStorage.getItem('md_recent_products')||'[]')}catch(e){}handles=handles.filter(h=>h&&h!==current);const limit=Number(rv.dataset.limit||4);const grid=qs('[data-recently-viewed-grid]',rv);Promise.all(handles.slice(0,limit).map(async h=>{try{const r=await fetch(`${root}products/${h}.js`);return r.ok?await r.json():null}catch(e){return null}})).then(items=>{const good=items.filter(Boolean);if(grid)grid.innerHTML=good.map(p=>`<article class="product-card"><a href="${p.url}"><div class="product-card__image">${p.featured_image?`<img src="${p.featured_image}" alt="${escapeHtmlV6(p.title)}" loading="lazy">`:''}</div><div class="product-card__meta"><div class="product-card__top"><h3>${escapeHtmlV6(p.title)}</h3><span class="price">€${(p.price/100).toFixed(2)}</span></div></div></a></article>`).join('');});if(current){handles=[current,...handles].filter((v,i,a)=>a.indexOf(v)===i).slice(0,8);localStorage.setItem('md_recent_products',JSON.stringify(handles));}}

    if(document.body.dataset.revealEnabled==='true'){
      const obs=new IntersectionObserver(es=>es.forEach(x=>{if(x.isIntersecting)x.target.classList.add('is-visible')}),{threshold:.08});
      qsa('.story-card,.trust-item,.product-story-card,.md-countdown__inner,.collection-campaign__copy').forEach(el=>{el.setAttribute('data-reveal','');obs.observe(el)});
    }
  });
  function escapeHtmlV6(str=''){const d=document.createElement('div');d.textContent=str;return d.innerHTML;}
})();
(() => {
  document.addEventListener('DOMContentLoaded',()=>{
    if(document.body.dataset.parallax==='true' && window.matchMedia('(min-width:901px)').matches){const media=document.querySelector('.hero__media');if(media){const move=()=>{const y=Math.min(90,window.scrollY*.08);media.style.transform=`translate3d(0,${y}px,0) scale(1.04)`};move();window.addEventListener('scroll',move,{passive:true});}}
    const sticky=document.querySelector('[data-mobile-sticky-buy]'), form=document.querySelector('.product-form');if(sticky&&form){const sync=()=>sticky.classList.toggle('is-visible',window.scrollY>520 && !document.body.classList.contains('cart-open'));sync();window.addEventListener('scroll',sync,{passive:true});sticky.querySelector('[data-sticky-buy]')?.addEventListener('click',()=>form.requestSubmit());}
  });
})();

/* ===== MD CLOTHING V7 / QUICK VIEW + EDITORIAL INTERACTIONS ===== */
(() => {
  const qs=(s,c=document)=>c.querySelector(s), qsa=(s,c=document)=>[...c.querySelectorAll(s)];
  const root=window.Shopify?.routes?.root || '/';
  const esc=(v='')=>{const d=document.createElement('div');d.textContent=v;return d.innerHTML};
  const money=(cents=0,currency='EUR')=>{try{return new Intl.NumberFormat(document.documentElement.lang||'bg-BG',{style:'currency',currency}).format(cents/100)}catch(e){return `€${(cents/100).toFixed(2)}`}};

  document.addEventListener('DOMContentLoaded',()=>{
    if(document.body.dataset.revealEnabled==='true'){const allReveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');allReveal.unobserve(entry.target)}}),{threshold:.06,rootMargin:'0px 0px -4% 0px'});qsa('[data-reveal]').forEach(el=>allReveal.observe(el));}
    const shell=qs('[data-quick-view-shell]'), body=qs('[data-quick-view-body]',shell);
    const close=()=>{shell?.classList.remove('is-open');shell?.setAttribute('aria-hidden','true');document.body.classList.remove('quick-view-open')};
    qsa('[data-quick-view-close]').forEach(b=>b.addEventListener('click',close));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});

    document.addEventListener('click',async e=>{
      const trigger=e.target.closest('[data-quick-view]');
      if(!trigger) return;
      e.preventDefault(); e.stopPropagation();
      const handle=trigger.dataset.productHandle;
      if(!handle||!shell||!body) return;
      shell.classList.add('is-open'); shell.setAttribute('aria-hidden','false'); document.body.classList.add('quick-view-open');
      body.innerHTML='<div class="quick-view__loading">Зареждане…</div>';
      try{
        const r=await fetch(`${root}products/${encodeURIComponent(handle)}.js`,{headers:{Accept:'application/json'}});
        if(!r.ok) throw new Error('product');
        const p=await r.json();
        const media=(p.images||[]).slice(0,2);
        const variants=(p.variants||[]);
        const active=variants.find(v=>v.available)||variants[0];
        body.innerHTML=`
          <div class="quick-view__gallery">
            ${media.map((src,i)=>`<div class="quick-view__image"><img src="${src}${src.includes('?')?'&':'?'}width=1000" alt="${esc(p.title)}" loading="eager">${i===0?'<span>01</span>':''}</div>`).join('')}
          </div>
          <div class="quick-view__info">
            <span class="eyebrow">MD CLOTHING / QUICK SHOP</span>
            <h2>${esc(p.title)}</h2>
            <div class="quick-view__price" data-qv-price>${money(active?.price||p.price)}</div>
            ${variants.length>1?`<label class="quick-view__label">Размер / вариант</label><select data-qv-variant>${variants.map(v=>`<option value="${v.id}" data-price="${v.price}" ${v.id===active?.id?'selected':''} ${!v.available?'disabled':''}>${esc(v.title)}${!v.available?' — Изчерпан':''}</option>`).join('')}</select>`:`<input type="hidden" data-qv-variant value="${active?.id||''}">`}
            <button class="btn btn--dark btn--wide quick-view__add" type="button" data-qv-add ${active&&!active.available?'disabled':''}>${active&&active.available?'ДОБАВИ В КОЛИЧКАТА':'ИЗЧЕРПАН'} <span>→</span></button>
            <a class="quick-view__full" href="${p.url}">ВИЖ ПЪЛНАТА СТРАНИЦА →</a>
          </div>`;
        const sel=qs('[data-qv-variant]',body), price=qs('[data-qv-price]',body), add=qs('[data-qv-add]',body);
        sel?.addEventListener('change',()=>{const opt=sel.selectedOptions?.[0];if(opt&&price)price.textContent=money(Number(opt.dataset.price||0));});
        add?.addEventListener('click',async()=>{
          const id=sel?.value; if(!id) return;
          const original=add.innerHTML;add.disabled=true;add.textContent='Добавяне…';
          try{const rr=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});if(!rr.ok)throw new Error('cart');close();setTimeout(()=>qs('[data-cart-open]')?.click(),160)}catch(err){add.disabled=false;add.innerHTML=original;}
        });
      }catch(err){body.innerHTML='<div class="quick-view__error"><strong>Неуспешно зареждане.</strong><p>Отвори продукта, за да видиш детайлите.</p></div>'}
    });

    /* Premium magnetic buttons — desktop only and intentionally subtle. */
    if(document.body.dataset.magneticButtons==='true' && window.matchMedia('(min-width: 901px) and (pointer:fine)').matches){
      qsa('.btn').forEach(btn=>{
        btn.addEventListener('mousemove',e=>{const r=btn.getBoundingClientRect();const x=(e.clientX-r.left-r.width/2)*.08,y=(e.clientY-r.top-r.height/2)*.08;btn.style.transform=`translate(${x}px,${y}px)`});
        btn.addEventListener('mouseleave',()=>btn.style.transform='');
      });
    }

    /* Gentle tilt only on campaign cards; disabled on touch. */
    if(window.matchMedia('(min-width: 901px) and (pointer:fine)').matches){
      qsa('.immersive-card,.drop-spotlight__media').forEach(card=>{
        card.addEventListener('mousemove',e=>{const r=card.getBoundingClientRect(),rx=((e.clientY-r.top)/r.height-.5)*-2,ry=((e.clientX-r.left)/r.width-.5)*2;card.style.transform=`perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`});
        card.addEventListener('mouseleave',()=>card.style.transform='');
      });
    }
  });
})();
